// @flow
import { getCreator, postCreator } from '../../http';
import environment from '../../environment';

export type SearchLocationRequest = {
  q?: string;
  inversenull?: number;
  types?: string;
};

const endpoints = Object.freeze({
  GET_LOCATION: `${environment.apiUrl}/geography/location/search`,
  POST_FLIGHT: `${environment.apiUrl}/flight/`,
});

export const searchLocationApi = getCreator(fetch, endpoints.GET_LOCATION);
export const postFlightApi = postCreator(fetch, endpoints.POST_FLIGHT);



// WEBPACK FOOTER //
// ./src/modules/new-flight/api.js